import React from 'react';
import { Icon } from '@openedx/paragon';
import { RiTimerLine, RiStarFill } from '@remixicon/react';

const CourseHeader = ({
  title, duration, rating, reviewCount, imageUrl,
}) => (
  <header className="course-detail__header">
    <h1 className="course-detail__title">{title}</h1>
    {/* Mobile-only: the course image sits next to the title here (CSS-hidden on
        desktop, where the purchase sidebar carries it instead). */}
    {imageUrl && (
      <div
        className="course-detail__header-image"
        role="img"
        aria-label={title}
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
    )}
    <div className="course-detail__meta">
      {duration && (
        <>
          <span className="course-detail__meta-item">
            <Icon src={RiTimerLine} size="xs" />
            {duration}
          </span>
          <span className="course-detail__meta-dot" />
        </>
      )}
      {rating != null ? (
        <span className="course-detail__meta-item">
          <Icon src={RiStarFill} size="xs" />
          {Number(rating).toFixed(1)} ({reviewCount.toLocaleString()} reviews)
        </span>
      ) : (
        <span className="course-detail__meta-item course-detail__meta-item--muted">
          No reviews yet
        </span>
      )}
    </div>
  </header>
);

export default CourseHeader;
